import ContentBox from "@mittwald/flow-components/dist/components/ContentBox";
import { color, duration, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Avatar } from "./Avatar";
import { Item } from "./Item";
export const Navigation = styled(ContentBox) `
  transition: width ${duration.animation.moderate}ms ease-in-out;
  padding: 0 ${spacing.base.m};

  &&.condensed {
    width: fit-content;

    ${Item}.active {
      ${Avatar} {
        border: ${size.border.base.hairline} solid ${color.status.info.default};
        margin: -1px;
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmF2aWdhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01haW5OYXZpZ2F0aW9uL3N0eWxlZC9OYXZpZ2F0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sVUFBVSxNQUFNLHNEQUFzRCxDQUFDO0FBQzlFLE9BQU8sRUFDTCxLQUFLLEVBQ0wsUUFBUSxFQUNSLElBQUksRUFDSixPQUFPLEdBQ1IsTUFBTSxnREFBZ0QsQ0FBQztBQUN4RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFFOUIsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsQ0FBQTtzQkFDdEIsUUFBUSxDQUFDLFNBQVMsQ0FBQyxRQUFRO2VBQ2xDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7Ozs7TUFLdkIsSUFBSTtRQUNGLE1BQU07a0JBQ0ksSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxVQUFVLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7O0NBSzdFLENBQUMifQ==